export function buildTransactionScheduleSummary(rows = []) {
    const totalCount = rows.length;
    const totalAmount = rows.reduce((sum, x) => sum + Number(x.paymentAmount || 0), 0);

    const emptyCount = rows.filter((x) => x.parentDisplayStatus === "EMPTY").length;
    const singleCount = rows.filter((x) => x.parentDisplayStatus === "SINGLE").length;
    const partialCount = rows.filter((x) => x.parentDisplayStatus === "PARTIAL").length;

    const fullyAgreedCount = rows.filter((x) => {
        const total = Number(x.allocationCount || 0);
        const agreed = Number(x.agreedAllocationCount || 0);
        return total > 0 && total === agreed;
    }).length;

    const waitingAgreeCount = rows.filter((x) => {
        const total = Number(x.allocationCount || 0);
        const agreed = Number(x.agreedAllocationCount || 0);
        return total > 0 && agreed < total;
    }).length;

    const reviewCount = rows.reduce((sum, x) => sum + Number(x.reviewAllocationCount || 0), 0);
    const returnedCount = rows.reduce((sum, x) => sum + Number(x.returnedAllocationCount || 0), 0);
    const verifiedCount = rows.reduce((sum, x) => sum + Number(x.verifiedAllocationCount || 0), 0);
    const outgoingPendingCount = rows.reduce(
        (sum, x) => sum + Number(x.outgoingPendingAllocationCount || 0),
        0,
    );

    return {
        totalCount,
        totalAmount,
        emptyCount,
        singleCount,
        partialCount,
        fullyAgreedCount,
        waitingAgreeCount,
        reviewCount,
        returnedCount,
        verifiedCount,
        outgoingPendingCount,
    };
}